import React from "react";
import SlickSlider from "./slider";
import {arrowStyle} from "../consts/arrowStyle"

/**Кастомные стрелки (след)*/
const SampleNextArrow = (props) => {
  const {className, style, onClick} = props;
  return (
    <div
      aria-hidden="true"
      className={className}
      style={{
        ...style,
        ...arrowStyle,
        left: '-1%',
      }}
      onClick={onClick}
      onKeyDown={onClick}
    >
      <i className="fas fa-arrow-left"/>
    </div>
  );
}

/**Кастомные стрелки (пред)*/
const SamplePrevArrow = (props) => {
  const {className, style, onClick} = props;
  return (
    <div
      aria-hidden="true"
      className={className}
      style={{
        ...style,
        ...arrowStyle,
        right: '-1%',
      }}
      onClick={onClick}
      onKeyDown={onClick}
    >
      <i className="fas fa-arrow-right"/>
    </div>
  );
}

/**Настройки слайдера*/
let settings = {
  nextArrow: <SampleNextArrow/>,
  prevArrow: <SamplePrevArrow/>,
  speed: 1000,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,

};

const GallerySlider = ({gallery}) => {

  return (
    <div className="container gallery-container">
      <SlickSlider settings={settings}>
        {gallery.map(item => (
          <img
            src={item.src}
            alt={item.alt}
            key={item.id}
            title={item.alt}
            width="1120px"
            height="747px"
          />
        ))}
      </SlickSlider>
    </div>
  );
}

export default GallerySlider;